// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__f4+qB","banner":"Banner_banner__7KCUI","illustration":"Banner_illustration__Wz6V9","pageName":"Banner_pageName__iwQBf"};